import styled from "styled-components";

const Target = styled.div`
  position: relative;
  top: 0;
  visibility: hidden;
  height: 0;
  scroll-margin-top: 80px; // Adjustable based on header height
`;

export default function AnchorTarget({ targetId }: { targetId: string }) {
  return <Target id={targetId} />;
}
